
import UseIcon from '@/components/UseIcon/UseIcon.vue';
import { defineComponent, SetupContext } from 'vue';

interface SetupReturn {
    emit: SetupContext['emit'];
}

export default defineComponent({
    components: { UseIcon },
    setup(props, { emit }: SetupContext): SetupReturn {
        return {
            emit,
        };
    },
});
